import { render, staticRenderFns } from "./SubType.vue?vue&type=template&id=0636e194&scoped=true"
import script from "./SubType.vue?vue&type=script&lang=js"
export * from "./SubType.vue?vue&type=script&lang=js"
import style0 from "./SubType.vue?vue&type=style&index=0&id=0636e194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636e194",
  null
  
)

export default component.exports